import Model from './Model'

export default class DeliveryModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'deliveries'
  }
}
